module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancies":"Jobs","myVacancies":"My jobs","archive":"Archive","integrations":"Integrations","selectUserLabel":"Select user","upgradePlan":"Increase the tariff","importVacanciesFromHH":"Import vacancies from HeadHunter","importVacanciesFromHHShort":"Import vacancies from HH","required":"Required field"}}')
  delete Component.options._Ctor
}
